import React from 'react';
import { Result } from 'antd';

const ServiceRemoved = (): JSX.Element => (
  <div>
    <Result
      status="warning"
      title="Service has been removed"
      subTitle="The Data Platform service has been removed and is no longer available."
    />
  </div>
);

export default ServiceRemoved;
